export enum MercerNewHireState {
  ForReview = 'ForReview',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Unassigned = 'Unassigned'
}
